export default __webpack_public_path__ + "static/media/Relevamiento de equipos diagnóstico.ad670184.pdf";